import React, { useState } from "react";
import styles from "./GamePlexPlans.module.css";

const plans = [
  {
    id: "daily",
    name: "GamePlex_Daily",
    price: "$1.99",
    duration: "1 Day",
  },
  {
    id: "weekly",
    name: "GamePlex_Weekly",
    price: "$5.99",
    duration: "7 Days",
  },
  {
    id: "monthly",
    name: "GamePlex_Monthly",
    price: "$14.99",
    duration: "30 Days",
  },
];

export default function GamePlexPlans() {
  const [selectedPlan, setSelectedPlan] = useState(null);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2 className={styles.title}>Choose Your Plan</h2>
        <p className={styles.subtitle}>
          Select a GamePlex subscription package
        </p>

        <div className={styles.plans}>
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`${styles.plan} ${
                selectedPlan === plan.id ? styles.active : ""
              }`}
              onClick={() => setSelectedPlan(plan.id)}
            >
              <h3>{plan.name}</h3>
              <p className={styles.duration}>{plan.duration}</p>
              <p className={styles.price}>{plan.price}</p>
            </div>
          ))}
        </div>

        <button
          className={styles.button}
          disabled={!selectedPlan}
        >
          {selectedPlan
            ? `Subscribe to ${plans.find(p => p.id === selectedPlan).name}`
            : "Select a Plan"}
        </button>
      </div>
    </div>
  );
}